import { render, staticRenderFns } from "./file_tree_browser.vue.js?vue&type=template&id=8c83c4be&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./file_tree_browser.vue?vue&type=template&id=8c83c4be&vue3"
import script from "./file_tree_browser.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./file_tree_browser.vue?vue&type=script&lang=js&vue3"
export * from "./file_tree_browser.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./file_tree_browser.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports